import { render, staticRenderFns } from "./RadiosDirection.vue?vue&type=template&id=bed35d68&"
import script from "./RadiosDirection.vue?vue&type=script&lang=js&"
export * from "./RadiosDirection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports